// extracted by mini-css-extract-plugin
export default {"container":"СampaignTypeSpecificSettings_container__uVe3e","title":"СampaignTypeSpecificSettings_title__KTSgo"};